import React, {Fragment} from 'react'

export default ({text='Lade'}) =>
  <Fragment>
    <i className="fas fa-spinner fa-spin"/>{' '}{text}
  </Fragment>



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/Spinner.js